import React from 'react';
import { Badge } from '@mantine/core';
import { DELIVERY_STATUS_ENUM_VALUES } from '../../api_enums/DELIVERY_STATUS_ENUM';

export function DeliveryStatusElement(props: { status: string }) {
  const statusDetails = DELIVERY_STATUS_ENUM_VALUES.get(props.status);
  if (statusDetails) {
    const Icon = statusDetails.icon;
    const color = statusDetails.color;
    return (
      <Badge
        sx={{ paddingLeft: 5, paddingTop: 5, paddingBottom: 2 }}
        size="lg"
        radius="md"
        color={color}
        leftSection={<Icon size={12} />}
      >
        {statusDetails.label}
      </Badge>
    );
  } else {
    console.warn('unknown status');
    return <>{props.status}</>;
  }
}
